import { arrayNodeDef } from "./array";
import { randomLengthArrayNodeDef } from "./random-length-array";
import { createNodeDef } from "../nodes.helpers";
import { DataFieldType } from "src/types/data-field.types";

const allowedTypes = new Set<string>([
  arrayNodeDef.type,
  randomLengthArrayNodeDef.type,
]);

export const arrayIndexNodeDef = createNodeDef({
  type: "arrayIndex",
  displayName: "Array Index",
  description: "Provides the current index when used inside an array.",
  defaultName: "index",
  initialData: () => ({ startWith: 0 }),
  fields: [
    { type: DataFieldType.NUMBER, key: "startWith", label: "Start with" },
  ],
  generate: ({ node, context }) => {
    const { startWith } = node.data;
    const latestCounter = context.getLatest((item) => {
      return (
        allowedTypes.has(item.nodeType) &&
        item.name.endsWith("Index") &&
        Number.isInteger(item.value)
      );
    });

    const index = latestCounter ? (latestCounter.value as number) : 0;
    return startWith + index;
  },
});
